import React from "react";
import * as Scrivito from "scrivito";
import NiceModal from "@ebay/nice-modal-react";
import { ModalBody, ModalHeader } from "reactstrap";
import { useTranslate } from "hooks";
import { ProductListWithControls } from "../ProductListOfProject/ProductListWithControls";
import { ModalWrapper } from "../ModalWrapper";

type Props = {
  nodeId: string;
  wizardTitle: string;
};

export const PriceCalculationModal = NiceModal.create(
  Scrivito.connect(({ nodeId, wizardTitle }: Props): React.ReactElement => {
    const translate = useTranslate();
    const modal = NiceModal.useModal();

    return (
      <ModalWrapper
        isOpen={modal.visible}
        centered={true}
        size="xl"
        toggle={modal.hide}
        className="my-0"
        isLoading={false}
      >
        <div className="d-flex flex-column position-relative">
          <ModalHeader
            toggle={modal.hide}
            tag="div"
            className="d-flex align-items-start pb-0 sticky-top z-3"
          >
            <h3 className="text-uppercase mb-1">
              {translate("PRICE_CALC_MODAL_TITLE")}
            </h3>
            <h4 className="mb-2">{wizardTitle}</h4>
          </ModalHeader>
          <ModalBody className="pt-2_5">
            <div className="w-100 flex-grow-1">
              <ProductListWithControls nodeId={nodeId} isModalView={true} />
            </div>
          </ModalBody>
        </div>
      </ModalWrapper>
    );
  }),
);
